<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/as-page-header"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="controls/bs-form-lookup"></require>

  <as-form-section heading="Select Roles" intro="Please select which roles you want to transfer.">
    <div slot="body">
      <div class="form-row">
        <div class="col-md-4">
          <div class="form-group">
            <h6>Approver for</h6>
            <div class="form-check" repeat.for="item of model.countriesApprove">
              <input class="form-check-input" type="checkbox" checked.bind="item.checked" id="__checklist-item-${$index}">
              <label class="form-check-label" for="__checklist-item-${$index}" innerhtml="${item.country.name}"></label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <h6>Contact for</h6>
            <div class="form-check" repeat.for="item of model.countriesContact">
              <input class="form-check-input" type="checkbox" checked.bind="item.checked" id="__checklist-item-${$index}">
              <label class="form-check-label" for="__checklist-item-${$index}" innerhtml="${item.country.name}"></label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <h6>Delegate of</h6>
            <div class="form-check" repeat.for="item of model.delegateApprovers">
              <input class="form-check-input" type="checkbox" checked.bind="item.checked" id="__checklist-item-${$index}">
              <label class="form-check-label" for="__checklist-item-${$index}" innerhtml="${item.user.fullName}"></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Assign To" intro="Please select user to whom you want to transfer roles.">
    <div slot="body">
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-lookup label.bind="userGroupLabel" placeholder="Find by surname, login or email" item.bind="model.transferTo & validate" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" disabled.bind="controller.disabled" tooltip="Type to search for bp employee, then pick the one from the list"></bs-form-lookup>
        </div>
      </div>
    </div>
  </as-form-section>
</template>
